import { Grid, Typography, Box } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NodataImage from "../../assets/failedImage.png"
import ButtonComponent from "../ButtonComponent/Button";


const Failed = () => { 
    const { id } = useParams();
    const navigate = useNavigate();
    const paymentPage = localStorage.getItem('URL');

    useEffect(() => {
        if (!localStorage.getItem('token')) {
            navigate('/login');
        }
        
    }, []);

    

    console.log('id', id);
    return(
        <Grid>
            <Box className="nodata-container">
                  <div className="image-data">
                  <img src={NodataImage} alt="No Data" className='failedImage' />
                  </div>
                  <Typography variant="h4" className="subscription-failed">Subscription Failed</Typography>
                  <Typography variant="h6" className="failed-description">We haven’t found any document. Please upload invoice</Typography>
                  <Box className="failed-button">
                    <ButtonComponent
                        onClick={() => navigate('/subscription')}
                        text="View Pricing Plans"
                        className="cancel-button"
                    />
                    <ButtonComponent
                     onClick={() => window.open(paymentPage, '_blank')}
                        text="Continue with Payment"
                        className="analyse-upload"
                    />
                  </Box>
            </Box>
        </Grid>
    )

}

export default Failed;